<template>
  <div class="wrapper" style="height: 100vh;">
      <div v-show="isLoaing" class="text-center" style="position:absolute; padding-top: 130px; text-align:center; width:100%; ">
        <img src="./img/async-loading-spinner.gif" style="width: 100px; height: 66px;"/>
      </div>
        <div class="container a-coupon">
            <h1 class="a-coupon__title">
                <span class="underline">A STATION 스타시티</span>를 <br>
                방문해 주셔서 감사드립니다.
            </h1>

            <div class="a-coupon__product">
                <img src="@/assets/images/@coupon_thumb.png" alt="">
            </div>
            <p class="a-coupon__product-text">제공되는 음료의 종류는 현장 상황에 따라 변경될 수 있습니다.</p>
            <dl class="a-coupon__info">
                <div class="a-coupon__info-row">
                    <dt class="a-coupon__info-title">쿠폰명</dt>
                    <dd class="a-coupon__info-desc">XS 에너지 드링크 교환권</dd>
                </div>
                <div class="a-coupon__info-row">
                    <dt class="a-coupon__info-title">사용처</dt>
                    <dd class="a-coupon__info-desc">A STATION 스타시티 컨시어지</dd>
                </div>
                <div class="a-coupon__info-row">
                    <dt class="a-coupon__info-title">사용기한</dt>
                    <dd class="a-coupon__info-desc">받은 당일에만 교환 가능</dd>
                </div>
                <div class="a-coupon__info-row">
                    <dt class="a-coupon__info-title">사용안내</dt>
                    <dd class="a-coupon__info-desc">A STATION 스타시티 컨시어지 <br>직원에게 본 화면을 보여주시면<br><span class="underline">직원 확인 후 음료를 교환</span>해 드립니다.</dd>
                </div>
            </dl>

            <div class="a-coupon__button-wrap">
                <!-- 교환 전 -->
                <p class="a-coupon__button-text">버튼을 클릭 시 교환 완료 처리되니 주의해 주세요.</p>
                <button type="button" class="a-coupon__button" v-if="isOpen" @click="loadCouponExchange">직원 확인</button>
                <!-- 교환 전 -->
                <!-- 교환 완료 -->
                <button type="button" class="a-coupon__button" v-if="isUsed" disabled>교환 완료</button>
                <!-- // 교환 완료 -->
                <!-- 교환 완료 -->
                <button type="button" class="a-coupon__button" v-if="isExpired" disabled>사용기간만료</button>
                <!-- // 교환 완료 -->
                <!-- 교환 완료 -->
                <button type="button" class="a-coupon__button" v-if="isCorrect" disabled>잘못된 쿠폰입니다</button>
                <!-- // 교환 완료 -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
  setup () {
    // 숫자 타입에서 쓸 수 있도록 format() 함수 추가

  }
}
</script>

<script>

// Library
import Vue from 'vue'
import axios from 'axios'

export default {
  name: 'astationCoupon',
  components: {

  },
  data () {
    return {
      hashCode : {
        type : String,
        default : ''
      },
      status: {
        type: Number,
        default : 0
      },
      loading: {
        type : Boolean,
        default: false
      }
    }
  },
  computed: {
    isOpen() {
      return this.status == 200
    },

    isExpired () {
      return this.status == 201
    },

    isUsed () {
      return this.status == 202
    },

    isCorrect () {
      return this.status == 203
    },

    isLoaing () {
      return this.loading
    }
  },
  methods: {
    init: async function () { // 초기화
      let key = this.$route.query.key

      if (key == undefined) {
        console.log("쿠폰정보가 없습니다.")
        this.loading = false
      } else {
        this.loading = true
        this.hashCode = key
        this.loadCouponValidation()
      }
    },

    showLayerAttinment: function (layerId) {
      var targetLayer = document.querySelector('#' + layerId)
      targetLayer.classList.add('showing')
      $('html, body').addClass('scroll-off')
    },
    showLayerOrderList: async function (layerId, aboNo, name, privacy) {
      this.aboOrderInfo = {'aboNo': aboNo, 'name': name, 'privacy': privacy}
      await this.loadAboOrderList()
      var targetLayer = document.querySelector('#' + layerId)
      targetLayer.classList.add('showing')
      $('html, body').addClass('scroll-off')
    },

    loadCouponValidation: async function () {
      await axios.post(
        process.env.AWS_GATEWAY_URL_V2 + '/astation/validation',
        {
          key: this.hashCode
        }).then(response => {

          this.status = response.data.status
          this.loading = false

        }).catch(error => {
          this.loading = false
          console.log('error : ', error)
          alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
        })
    },

    loadCouponExchange: async function () {

      if ( !confirm('쿠폰을 사용하시겠습니까?') ) {
        return
      }else {
        this.loading = true

        await axios.post(
          process.env.AWS_GATEWAY_URL_V2 + '/astation/exchange',
          {
            key: this.hashCode
          }).then(response => {

            if (response.data.status == '200'){
              this.status = 202
              alert("쿠폰사용이 완료되었습니다.")
            }else {
              this.status = response.data.status
              alert(response.data.statusMessage)
            }

            this.loading = false

          }).catch(error => {
            this.loading = false
            console.log('error : ', error)
            alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
          })
      }
    },

  },
  mounted: function () {
    this.init()
  },
  created: function () {

  }
}
</script>

<style scoped>

/* reset */
html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video { margin: 0; padding: 0; border: 0; font-size: 100%; font: inherit; vertical-align: baseline; }
article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section { display: block; }
body { line-height: 1.2; }
ol, ul { list-style: none; }
blockquote, q { quotes: none; }
blockquote:before, blockquote:after, q:before, q:after { content: ''; content: none; }
table { border-collapse: collapse; border-spacing: 0; }
html,body{ height: 100vh; font-family: 'Roboto', 'Noto Sans KR', sans-serif; box-sizing: border-box;}
img{ width: 100%; max-width: 100%; }
*,*::before, ::after{ box-sizing: border-box; }

@font-face { font-family:'Noto Sans KR'; font-style:normal; font-weight:300; src:url(https://www.amway.co.kr/_ui/responsive/theme-blue/fonts/notosanskr/notokr-light.woff2) format('woff2'), url(https://www.amway.co.kr/_ui/responsive/theme-blue/fonts/notosanskr/notokr-light.woff) format('woff') ; }
@font-face { font-family:'Noto Sans KR'; font-style:normal; font-weight:400; src:url(https://www.amway.co.kr/_ui/responsive/theme-blue/fonts/notosanskr/notokr-regular.woff2) format('woff2'), url(https://www.amway.co.kr/_ui/responsive/theme-blue/fonts/notosanskr/notokr-regular.woff) format('woff') ; }
@font-face { font-family:'Noto Sans KR'; font-style:normal; font-weight:500; src:url(https://www.amway.co.kr/_ui/responsive/theme-blue/fonts/notosanskr/notokr-medium.woff2) format('woff2'), url(https://www.amway.co.kr/_ui/responsive/theme-blue/fonts/notosanskr/notokr-medium.woff) format('woff') ; }
@font-face { font-family:'Noto Sans KR'; font-style:normal; font-weight:700; src:url(https://www.amway.co.kr/_ui/responsive/theme-blue/fonts/notosanskr/notokr-bold.woff2) format('woff2'), url(https://www.amway.co.kr/_ui/responsive/theme-blue/fonts/notosanskr/notokr-bold.woff) format('woff') ; }
.wrapper{ width: 100%; height: 100%; max-width: 720px; padding: 30vw 0 0; background: url(https://www.amway.co.kr/_ui/responsive/theme-blue/images/a-station/bg_a_content_layout.png) 0 0 no-repeat #f6f8ef; background-size: 100% auto; box-sizing: border-box;overflow-y: auto;overflow-x: hidden;}
.container{ width: 78vw; margin: 0 auto; }
.a-coupon__title{ text-align: center; font-weight: 700; font-size: 15px; line-height: 1.5; }
.underline{ display: inline-block; position: relative; z-index: 1; }
.underline::before{ content: ''; position: absolute; bottom: 0; left: 0; z-index: -1; width: 100%; height: 9px; background: #fff6c7; opacity: .7; }
.a-coupon__product{ display: flex; align-items: center; justify-content: center; width: 100%; max-width: 55vw; height: 130px; margin: 6vw auto 0; }
.a-coupon__product img{ width: 130px; }
.a-coupon__product-text{ font-size: 8px; color: #bdbdbd; letter-spacing: -1px; text-align: center; margin-top: 2vw; }
.a-coupon__info{ margin-top: 3vw; }
.a-coupon__info-row{ display: flex; margin: 2vw 0; padding: 0 10vw 0 13vw; }
.a-coupon__info-title{ width: 50px; min-width: 50px; font-size: 10px; color: #808080; line-height: 1.6; }
.a-coupon__info-desc{ font-size: 10px; color: #1a1a1a; letter-spacing: -1px; line-height: 1.6; }
.a-coupon__button-wrap{ margin-top: 12vw; text-align: center; }
.a-coupon__button-text{ font-size: 10px; color: #727c50; }
.a-coupon__button{ width: 180px; height: 40px; margin-top: 2vw; border-radius: 40px; outline: 0; border: 0; background: #727c50; font-weight: 700; font-size: 12px; color: #fff; }
.a-coupon__button:disabled{background: #cdcdcd; cursor: not-allowed;margin-top: calc(2vw + 12px);}
.a-coupon__info-desc .underline::before{ background: #e1ff7b; }
@media (min-width: 390px ) {
    .a-coupon__button-wrap{ margin-top: 18vw; }
}
@media (max-width: 350px ) {
    .a-coupon__button-wrap{ margin-top: 3vw; }
}
</style>



// WEBPACK FOOTER //
// src/views/astation/coupon.vue